export default __webpack_public_path__ + "static/media/rolandGarros.7cf46709.svg";